import moment from 'moment';
import XLSX from 'xlsx';
import { PDFDocument } from 'pdf-lib';
import ApplicationModel from '../../models/ApplicationModel';
import '../../lib/math_uuid';

const formatDollars = number => (number ? `$${number.toLocaleString()}` : number);

function getUUId(){
  return Math.uuidFast();
}

const getCurrentTime = () => {
  const d = new Date();
  const year = d.getFullYear();
  const month = `${d.getMonth() + 1 < 10 ? '0' : ''}${d.getMonth() + 1}`;
  const day = `${d.getDate() < 10 ? '0' : ''}${d.getDate()}`;
  const hours = `${d.getHours() < 10 ? '0' : ''}${d.getHours()}`;
  const minutes = `${d.getMinutes() < 10 ? '0' : ''}${d.getMinutes()}`;
  const seconds = `${d.getSeconds() < 10 ? '0' : ''}${d.getSeconds()}`;
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const exportTxtFile = (fileName, list)=>{
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  let content = '';
  list.forEach(text => {
    content += `${text.displayId}, ${text.name}, ${text.question}`+'\n';
  });
  const blob = new Blob([content], {type: "octet/stream"});
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

// 動產抵押匯出
const exportFileToBlobUrl = (fileName, columns, memberList) => {
  console.log(`columns === ${JSON.stringify(columns)}`);
  console.log(`memberList === ${JSON.stringify(memberList)}`);
  const list = [];
  const cols = [];
  columns.push({name:'電話', key: 'cellphone'});
  columns.push({name:'專案代碼', key: 'promotionNo'});

  columns.forEach((col) => {
    cols.push(col.name);
  });

  list.push(cols);
  memberList.forEach((member) => {
    const values = [];
    columns.forEach((cur) => {
      if (cur.key === 'birthday' || cur.key === 'startDate' || cur.key === 'endDate') {
        values.push(`${member[cur.key].year}-${member[cur.key].month}-${member[cur.key].day}`);
      } else if (cur.key === 'parentAgentName') {
        values.push(member.parentAgent.displayName);
      } else if (cur.key === 'caseType') {
        const type = member[cur.key]
        if ( type ===  '0' || type ===  0) {
          values.push("優加");
        } else if ( type ===  '1' || type ===  1) {
          values.push("優質");
        } else if ( type ===  '2' || type ===  2) {
          values.push("一般");
        } else if ( type ===  '3' || type ===  3) {
          values.push("超優");
        } else {
          values.push("一般");
        }
      } else if (cur.key === 'caseStatus') {
        values.push(getCaseStatus(member));
      } else if (cur.key === 'category') {
        values.push(member.promotionNo);
        // values.push(getCaseProduct(member.vendor ? member.vendor.productId : '', member[cur.key]));
      } else {
        values.push(member[cur.key]);
      }
    });
    list.push(values);
  });
  const ws = XLSX.utils.aoa_to_sheet(list);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate file and send to client */
  XLSX.writeFile(wb, `${fileName}.xlsx`);
  return { fileName };
};

// 撥款清單
const exportPriceFile = (fileName, columns, memberList) => {
  console.log(`columns === ${JSON.stringify(columns)}`);
  console.log(`memberList === ${JSON.stringify(memberList)}`);
  const list = [];
  const cols = [];

  columns.forEach((col) => {
    cols.push(col.text);
  });

  list.push(cols);
  memberList.forEach((member) => {
    const values = [];
    columns.forEach((cur) => {
      if (cur.value === 'productName') {
        values.push(getCaseProduct(member.productId, member.category))
      } else if (cur.value === 'caseStatus') {
        values.push(getCaseStatus(member))
      } else if (cur.value === 'caseType') {
        values.push(getCaseType(member))
      } else {
        values.push(member[cur.value]);
      }
    });
    list.push(values);
  });
  const ws = XLSX.utils.aoa_to_sheet(list);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate file and send to client */
  XLSX.writeFile(wb, `${fileName}.xlsx`);
  return { fileName };
}


// 經銷
const exportAgentListFile = (fileName, columns, dataList) => {
  console.log(`columns === ${JSON.stringify(columns)}`);
  console.log(`dataList === ${JSON.stringify(dataList)}`);
  const list = [];
  const cols = [];

  columns.forEach((col) => {
    cols.push(col.text);
  });

  list.push(cols);
  dataList.forEach((item) => {
    const values = [];
    columns.forEach((cur) => {
      values.push(item[cur.key]);
    });
    list.push(values);
  });
  const ws = XLSX.utils.aoa_to_sheet(list);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate file and send to client */
  XLSX.writeFile(wb, `${fileName}.xlsx`);
  return { fileName };
}

// 內扣撥款清單
const exportCCHPaymentFile = (fileName, columns, dataList) => {
  console.log(`columns === ${JSON.stringify(columns)}`);
  console.log(`dataList === ${JSON.stringify(dataList)}`);
  const list = [];
  const cols = [];

  columns.forEach((col) => {
    cols.push(col.text);
  });

  list.push(cols);
  dataList.forEach((item) => {
    const values = [];
    columns.forEach((cur) => {
      values.push(item[cur.value]);
    });
    list.push(values);
  });
  const ws = XLSX.utils.aoa_to_sheet(list);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate file and send to client */
  XLSX.writeFile(wb, `${fileName}.xlsx`);
  return { fileName };
}

// 對保費
const exportInsureFile = (fileName, columns, dataList) => {
  const list = [];
  const cols = [];

  columns.forEach((col) => {
    cols.push(col.text);
  });

  list.push(cols);
  dataList.forEach((item) => {
    const values = [];
    columns.forEach((cur) => {
      values.push(item[cur.value]);
    });
    list.push(values);
  });
  const ws = XLSX.utils.aoa_to_sheet(list);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');
  /* generate file and send to client */
  XLSX.writeFile(wb, `${fileName}.xlsx`);
  return { fileName };
}

function getCaseProduct(productId, category) {
  if (category === 2 && productId === "0") {
    return "商品貸原融";
  }
  if (productId === "0") {
    return "機車原融";
  }
  if (productId === "1") {
    return "借新還舊";
  }
  if (productId === "2") {
    return "他行代償";
  }
  return "機車原融";
}

function getCaseType(item) {
  // //0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
  if (item.category === 2 && item.caseType === 3){
    return "超優";
  }

  if (item.category === 0 ||
    item.category === 2 ||
    item.category === 3) {
    const list = [
      { key: 0, value: "優加" },
      { key: 1, value: "優質" },
      { key: 2, value: "一般" },
      { key: 3, value: "借新還舊" },
      { key: 4, value: "他行代償" },
      { key: 5, value: "萬物代" }
    ];
    return list.find(i => i.key === item.caseType).value;
  }
  return "一般";
}

function getCaseStatus(item) {
  const list = [
    { key: 0, value: '待進件' },
    { key: 5, value: '已進件' },
    { key: 1, value: '婉拒' },
    { key: 2, value: '待捕' },
    { key: 3, value: '核准' },
    { key: 4, value: '附條件' },
    { key: 6, value: '已請款' },
    { key: 7, value: '原融已請款' },
    { key: 8, value: '原融已撥款' },
    { key: 9, value: '申覆' },
    { key: 10, value: '自退' },
    { key: 11, value: '撥款問題件' },
  ];
  const find = list.find(i => i.key === item.caseStatus);
  if (find){
    return find.value;
  }
  return '待進件';
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function addMonth(date){
  return moment(date).add(1, 'M').format('YYYY-MM-DD');
}


function formatDate(date) {
  return moment(date)
    .format('YYYY-MM-DD');
}

function customFormatDate(date, formatText) {
  return moment(date)
    .format(formatText);
}

function formatDateTime(date) {
  return moment(date)
    .format('YYYY-MM-DD HH:mm:ss');
}

function getNow() {
  const now = new Date();
  return moment(now)
    .format('YYYY-MM-DD HH:mm:ss');
}

function getNowAddYear() {
  const now = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  return moment(now)
    .format('YYYY-MM-DD HH:mm:ss');
}

function getCurrentDate() {
  const now = new Date();
  return moment(now)
    .format('YYYY-MM-DD');
}

function getCurrentFormatDate(formatText) {
  const now = new Date();
  if (formatText) {
    return moment(now)
      .format(formatText);
  }
  return moment(now)
    .format('YYYY-MM-DD');
}

function getTWFormatDate() {
  const now = new Date();
  const year = now.getFullYear() - 1911;
  const month = `${now.getMonth() + 1 < 10 ? '0' : ''}${now.getMonth() + 1}`;
  const day = `${now.getDate() < 10 ? '0' : ''}${now.getDate()}`;
  return `${year}/${month}/${day}`;
}

function getYesterday() {
  const yesterdayTime = new Date();
  yesterdayTime.setTime(yesterdayTime.getTime() - (24 * 60 * 60 * 1000));
  const yesterday = `${yesterdayTime.getFullYear()}-${(yesterdayTime.getMonth()+1)}-${yesterdayTime.getDate() < 10? `0${yesterdayTime.getDate()}` : `${yesterdayTime.getDate()}`}`;
  return yesterday;
}

function getTomorrow() {
  const tomorrowTime = new Date();
  tomorrowTime.setTime(tomorrowTime.getTime() + (24 * 60 * 60 * 1000));
  const tomorrow = `${tomorrowTime.getFullYear()}-${(tomorrowTime.getMonth()+1)}-${tomorrowTime.getDate()}`;
  return tomorrow;
}



function getFinanceUrl(agentId, caseCategory) {
  // const link = `http://localhost:8080/#/EditCreditProduct?caseCategory=0&editIndex=-1&agentId=${agentId}`;
  const link = `https://haorich.tw/#/EditCreditProduct?caseCategory=${caseCategory}&editIndex=-1&agentId=${agentId}`;
  return link;
}

function getMemberIdCityList() {
  return [
    { key: '10001', value: '北縣' },
    { key: '10002', value: '宜縣' },
    { key: '10003', value: '桃縣' },
    { key: '10004', value: '竹縣' },
    { key: '10005', value: '苗縣' },
    { key: '10006', value: '中縣' },
    { key: '10007', value: '彰縣' },

    { key: '10008', value: '投縣' },
    { key: '10009', value: '雲縣' },
    { key: '10010', value: '嘉縣' },
    { key: '10011', value: '南縣' },
    { key: '10012', value: '高縣' },
    { key: '10013', value: '屏縣' },
    { key: '10014', value: '東縣' },

    { key: '10015', value: '花縣' },
    { key: '10016', value: '澎縣' },
    { key: '10017', value: '基市' },
    { key: '10018', value: '竹市' },
    { key: '10020', value: '嘉市' },
    { key: '09007', value: '連江' },
    { key: '09020', value: '金門' },

    { key: '63000', value: '北市' },
    { key: '64000', value: '高市' },
    { key: '65000', value: '新北市' },

    { key: '66000', value: '中市' },
    { key: '67000', value: '南市' },
    { key: '68000', value: '桃市' },
  ];
}

function sortApplicationItem(result){
  const itemDetail = !result ? new ApplicationModel() : result;
  if (!itemDetail.caseId || itemDetail.caseId === "") {
    itemDetail.caseId = Math.uuidFast();
  }

  if(!itemDetail.customer.home.liveLevel2){
    itemDetail.customer.home.liveLevel2 = [
      { key: 0, value: false },
      { key: 1, value: false },
      { key: 2, value: false },
      { key: 3, value: false },
      { key: 4, value: false },
      { key: 5, value: false },
    ];
  }
  if(!itemDetail.jointGuarantor.home.liveLevel2){
    itemDetail.jointGuarantor.home.liveLevel2 = [
      { key: 0, value: false },
      { key: 1, value: false },
      { key: 2, value: false },
      { key: 3, value: false },
      { key: 4, value: false },
      { key: 5, value: false },
    ];
  }
  if(!itemDetail.laonhfcInfo.engineId) {
    itemDetail.laonhfcInfo.engineId = ''
  }

  itemDetail.customer.home.residenceContent = `${itemDetail.customer.home.residenceCity}${itemDetail.customer.home.residenceArea}${itemDetail.customer.home.residenceAddress}`;
  itemDetail.customer.home.homeContent = `${itemDetail.customer.home.homeCity}${itemDetail.customer.home.homeArea}${itemDetail.customer.home.homeAddress1}`;
  return itemDetail;
}

function ResizeImage(imageData) {
  const maxW = 800;
  const maxH = 600;
  let image = new Image();

  image.onload = function(){
    console.log(`image width === ${image.width} image height === ${image.height}`)
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    const iw = image.width;
    const ih = image.height;
    const scale = Math.min((maxW/iw),(maxH/ih));
    const iwScaled = iw * scale;
    const ihScaled = ih * scale;
    canvas.width = iwScaled;
    canvas.height = ihScaled;
    ctx.drawImage(image,0,0,iwScaled,ihScaled);
    return canvas.toDataURL();
  };

  image.src = imageData;
}

async function exportPdf(uploadedFiles) {
  // Create a new PDFDocument
  const pdfDoc = await PDFDocument.create();

  // const fileList = uploadedFiles.sort(function(a, b){
  //   if(a.content_type === 'pdf') { return -1; }
  //   return 0;
  // })
  const fileList = uploadedFiles;

  for (const file of fileList) {
    const fileType = file.content_type;
    if(fileType === `pdf`){
      const pdf = await PDFDocument.load(file.file_body_encode, { ignoreEncryption: true });
      const copiedPages = await pdfDoc.copyPages(pdf, pdf.getPageIndices());
      copiedPages.forEach((page) => {
        pdfDoc.addPage(page);
      });
    } else{
      const page = pdfDoc.addPage();
      const { width, height } = page.getSize();
      const imageFile =  (fileType === `png`) ? await pdfDoc.embedPng(file.file_body_encode) : await pdfDoc.embedJpg(file.file_body_encode);
      const widthScale = width / imageFile.width;
      const heightScale = height / imageFile.height;
      const scaleNumber = widthScale < heightScale ? widthScale : heightScale;
      const imageDims = imageFile.scale(scaleNumber);

      page.drawImage(imageFile, {
        x: page.getWidth() / 2 - imageDims.width / 2,
        y: page.getHeight() / 2 - imageDims.height / 2,
        width: imageDims.width,
        height: imageDims.height,
      })
    }
  }
  // Serialize the PDFDocument to bytes (a Uint8Array)
  const pdfBytes = await pdfDoc.saveAsBase64({ dataUri: true });
  return pdfBytes;
}

function yearPadLeft(str) {
  const padLength = 3
  str = '' + str;
  if (str.length >= padLength) {
      return str;
  } else if(str.length === 0) {
    return '';
  } else {
      return yearPadLeft("0" + str, padLength);
  }
}

function installmentOnlineList(key) {
  const list = {
    "A001" : "未申請",
    "A002" : "申請中",
    "A003" : "撥款中",
    "A004" : "已撥款",
  }
  return list[key]
}

function getCreditLoanFiles(itemInfo) {
  let files = [];
  if (itemInfo.memberIdImageURL1) {
    const data = {
      url:`${itemInfo.memberIdImageURL1}`,
      fileName:`身分證正面`
    }
    files.push(data)
  }

  if (itemInfo.memberIdImageURL2) {
    const data = {
      url:`${itemInfo.memberIdImageURL2}`,
      fileName:`身分證背面`
    }
    files.push(data)
  }

  if (itemInfo.salaryURL) {
    const data = {
      url:`${itemInfo.salaryURL}`,
      fileName:`薪資文件`
    }
    files.push(data)
  }
  return files
}

function isDuringDate(beginDateText, endDateText){
  const curDate = new Date(),
    beginDate = new Date(beginDateText),
    endDate = new Date(endDateText);
  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }
  return false;
}

export {
  formatDollars,
  getCurrentTime,
  formatDate,
  formatDateTime,
  getNow,
  getNowAddYear,
  getCurrentDate,
  getCurrentFormatDate,
  customFormatDate,
  addDays,
  getTWFormatDate,
  exportFileToBlobUrl, //  動產抵押申請書
  getFinanceUrl,
  getMemberIdCityList,
  exportTxtFile,
  exportPdf,
  yearPadLeft,
  sortApplicationItem,
  ResizeImage,
  exportPriceFile,
  installmentOnlineList,
  getCreditLoanFiles,
  isDuringDate,
  getYesterday,
  getTomorrow,
  getUUId,
  addMonth,
  exportCCHPaymentFile,
  exportAgentListFile,
  exportInsureFile
};



// WEBPACK FOOTER //
// ./src/pages/utils/tool.js